export const COMPLAINT_CONSTANT = {
  COMPLAINT_DATA: "/complainbox",
  COMPLAINT_SOFT_DELETE: "/complainbox/softDelete",
  COMPLAINT_LIST: "/complainbox/list",
  COMPLAINT_ADD_COMMENT: "/common/comment",
  COUNT_BY_STATUS: "/complainbox/count/status",
  COMPLAIN_COUNT: "/complainbox/count",
  VOTER_SEARCH: "/voter/search",
  CAST: "/cast",
  SUBCAST_WITH_CAST: "/common/subcast",
  CATEGORY_LIST: "/complainbox/categories",
  ADMIN_RECENT_COMPLAINT: "/dashboard/complain/list/recent",
  VISITOR_SEARCH: "/visitor/search",
  VISITORS_COMPLAINS: "/complainbox/by/visitor",
  COMPLAINT_ASSEMBLY:
    "?join=assembly&join=gat_number&join=gan_number&join=gaon",
  ASSEMBLIES_LIST: "/common/assemblies",
  GAON_LIST: "/common/gaon",
  GATNO_LIST: "/common/gat",
  GAN_NUMBER_LIST: "/common/gan",
  TOTAL_COUNT: "/complainbox/total/count",
  EXCEL_DOWNLOAD:"/complainbox/export",
  FLAG_DATE: [
    { name: "Regular", value: "regular" },
    { name: "End Date", value: "endDate" },
  ],
};
export const COMPLAIN_EXCEL_DATA = {
  COLUMN_DEFINATION: [
    {
      isObj: false,
      displayName: "Token Number",
      valueKey: ["tokenNumber"],
    },
    {
      isObj: true,
      displayName: "Category",
      obj: "category",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Category Type",
      obj: "type",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Complainer Name",
      obj: "complainer",
      valueKey: ["firstName", "middleName", "lastName"],
    },
    {
      isObj: true,
      displayName: "Complainer Phone",
      obj: "complainer",
      valueKey: ["phone"],
    },
    // {
    //   isObj: true,
    //   displayName: "Assign Karyakarta",
    //   obj: "karyaKarta",
    //   valueKey: ["firstName", "lastName", "phone"]
    // },
    // {
    //   isObj: true,
    //   displayName: "Assign Adhikari",
    //   obj: "adhikari",
    //   valueKey: ["firstName", "lastName", "phone"]
    // },
    {
      isObj: true,
      displayName: "Assembly",
      obj: "assembly",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Gat",
      obj: "gat_number",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Gan",
      obj: "gan_number",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Gaon",
      obj: "gaon",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Prabhag",
      obj: "prabhag",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Prabhag Area",
      obj: "prabhagArea",
      valueKey: ["name"],
    },
    {
      isObj: false,
      displayName: "Note",
      valueKey: ["description"],
    },
  ],
};